module.exports = __webpack_public_path__ + "img/contact-1.2dfa81b1.jpeg";